var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    transform: "translate(-0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1979",
    "data-name": "Rectangle 1979",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(0.463)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    d: "M17.041,18.823H14.078V14.182c0-1.107-.02-2.531-1.541-2.531-1.543,0-1.78,1.205-1.78,2.451v4.721H7.794V9.279h2.845v1.3h.039a3.119,3.119,0,0,1,2.807-1.541c3,0,3.557,1.976,3.557,4.545ZM4.45,7.974a1.72,1.72,0,1,1,1.72-1.72,1.719,1.719,0,0,1-1.72,1.72h0M5.931,18.823H2.965V9.279H5.931ZM18.519,1.783H1.475A1.46,1.46,0,0,0,0,3.225V20.338a1.46,1.46,0,0,0,1.475,1.443H18.519A1.463,1.463,0,0,0,20,20.338V3.224a1.463,1.463,0,0,0-1.481-1.442",
    transform: "translate(15 13.218)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.162691549e1a62ae1499af9ebaa1ad6c.svg";
export { ForwardRef as ReactComponent };